import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContextService } from 'src/services/platform/context.service';

@Component({
  selector: 'app-heading',
  templateUrl: './heading.component.html',
  styleUrls: ['./heading.component.scss'],
})
export class HeadingComponent implements OnInit {
  @Input() openSidePanel = false;
  @Input() selectedNav = '';
  @Input() showPageName: boolean;
  @Output() callbackFunction = new EventEmitter<any>();
  @Input() counter = {
    length: 0,
    current: 0,
  };
  languages: any;
  agent: any;

  constructor(private contextService: ContextService) {}

  ngOnInit(): void {
    this.languages = this.contextService.languages.leftPanelSignup;
    this.agent = this.contextService.languages.agent;
  }
  toggleSide() {
    this.callbackFunction.emit();
  }
}
